export const ProviderBrands = {
  konnect: "konnect",
};
